export default {
    when() {
        return document.querySelectorAll('.card--tenders').length > 0;
    },

    mounted() {
        $('.card--tenders').on('click', function() {
            const $this = $(this);
            const dataOpen = $this.attr('data-open');

            $('.card--tenders').removeClass('open');

            if (dataOpen == 'false') {
                $this.addClass('open');
                $this.find('.hidden__card').removeClass('hidden');
                $this.attr('data-open', true);
            } else {
                $this.removeClass('open');
                $('.card--tenders .hidden__card').addClass('hidden');
                $this.attr('data-open', false);
            }
        });
    },
};
